$('[data-optional-cookies="trigger"]').click(function () {
    const trigger = $(this).attr('data-switch');

    if (trigger == 'off') {
        $('[data-optional-cookies="target"]').attr('type', 'text/plain');
        $.cookie('optionalCookies', 'disabled', {
            path: '/', secure: true
        })
    } else {
        $('[data-optional-cookies="target"]').attr('type', 'text/javascript');
        $.cookie('optionalCookies', 'allowed', {
            path: '/', secure: true
        })
    }
})
